import React from "react";
import { ButtonCTAProps } from "./ButtonCTA.types";
import { StyledButton, StyledAnchor, Style } from "./ButtonCTA.style";
import { MdSearch } from "react-icons/md";

export default function ButtonCTA({
  asButton = false,
  styleButton,
  label,
  link,
  onClickAttribute,
  targetAttributte,
  disabled = false,
  className,
  iconCheck,
  backgroundcolor,
  buttonIcon,
}: ButtonCTAProps) {

  const commonProps = {
    className: `${styleButton || ""} ${className || ""}`.trim(),
    "aria-label": label,
  };

  if (asButton) {
    return (
      <Style $backgroundcolor={backgroundcolor} $iconcheck={iconCheck} className="style-button">
        <StyledButton
          {...commonProps}
          onClick={onClickAttribute}
          disabled={disabled}>
        {iconCheck && (
          <MdSearch aria-label="Buscar Imóveis" className="icon-button" size={24} fill="#ffffff"/>
        )}
        <span className="label-button">{label}</span>
      </StyledButton>

      </Style>
      
    );
  }

  return (
    <Style $backgroundcolor={backgroundcolor} $iconcheck={iconCheck} className="style-button">
      <StyledAnchor
        {...commonProps}
        href={!disabled ? link : undefined}
        target={!disabled ? targetAttributte : undefined}
        rel={!disabled ? "noopener noreferrer" : undefined}
        aria-disabled={disabled ? "true" : "false"}
      >
        {buttonIcon && (<img src={buttonIcon} alt="Ícone"/>)}
        {label}
      </StyledAnchor>
    </Style>
    
  );
}
